module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/logopedic-f6574003320849829feef4f0e6d11f4b.svg";